import React, { Component } from "react";
import "./App.css";
import Routes from "../routes/Routes";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import ProgressHeader from "./HeaderWithProgress/ProgressHeader";
import CustomerFeedback from "./CustomerFeedback/CustomerFeedback";
import { BrowserRouter } from "react-router-dom";
import { SpeakerContext } from "../context/SpeakerContext";
import { isNewUI } from "../utils/handleProgress";
import { shutterSound } from "../audios/commonAudio";
import "unified-ui-components-library/dist/designTokens.css";
import * as faceapi from 'face-api.js';
import { CAPS_N, CAPS_Y } from "../utils/constants";
import AppNavbar from "./AppNavbar/AppNavbar";

class App extends Component {
  constructor() {
    super()
    this.state = {
      isVoiceOverDisable: false,
      showbackButton: false,
      showAudioIcon: false,
      showOldHeader:false,
      showFooter: isNewUI()??false,
      faceDetectionModel: null,
      loadingFacedetectionModel: true,
      skipModelLoading: false,
      tinyFaceDetectionModel: localStorage.getItem("tinyFaceDetectionModel") ?? null,
      isNewHeader: this.isNewHeaderApplicable() ?? false,
    }
  }

  isNewHeaderApplicable = () => {
    return sessionStorage.getItem("isTelebinding") === CAPS_Y;
  }

  componentDidMount = () => {
    console.log(window.location)
    if (window.location.pathname !== '/selfie' || window.location.pathname !== '/video-consent') {
      const tinyFaceDetectionModel = localStorage.getItem("tinyFaceDetectionModel");
     if(tinyFaceDetectionModel === CAPS_Y || tinyFaceDetectionModel === CAPS_N) {
      this.loadFaceDetectionModel()
     }

    } else {
      this.setState({ skipModelLoading: true })
    }
  }

  loadFaceDetectionModel = () => {
    const isTinyFaceDetectionModel = localStorage.getItem("tinyFaceDetectionModel") === CAPS_Y;
    console.log({ isTinyFaceDetectionModel, m: localStorage.getItem("tinyFaceDetectionModel") })
    const detector = isTinyFaceDetectionModel ? 'tinyFaceDetector' : 'ssdMobilenetv1'
    faceapi.nets[detector].loadFromUri('/models').then((model)=>{
      console.log('Model loadded')
      this.setState({ faceDetectionModel: model, loadingFacedetectionModel: false })
    }).catch((err)=>{
      console.log('Err in facemesh model loading', err)
    })
  }

  handleVoiceOverState = (bool) => {
    this.setState({ isVoiceOverDisable: bool })
  }

  handlebackBtnDisplay = (bool) => {
    this.setState({ showbackButton: bool })
  }

  handleAudioIconDisplay = (bool) => {
    this.setState({ showAudioIcon: bool })
  }
  handleHeaderDisplay = (bool) => {
    this.setState({ showOldHeader: bool })
  }

  handleDisplayOfElements =(name, show)=>{
    this.setState({ [name]: show })
  }

  render() {
    const { isVoiceOverDisable, showbackButton, showAudioIcon, showOldHeader,showFooter, faceDetectionModel, loadingFacedetectionModel, skipModelLoading, isNewHeader } = this.state
    return (
      <>
        <SpeakerContext.Provider
          value={
            {
              isVoiceOverDisable,
              showbackButton,
              showAudioIcon,
              showOldHeader,
              showFooter,
              handleVoiceOverState: this.handleVoiceOverState,
              handlebackBtnDisplay: this.handlebackBtnDisplay,
              handleAudioIconDisplay: this.handleAudioIconDisplay,
              handleHeaderDisplay: this.handleHeaderDisplay,
              handleDisplayOfElements: this.handleDisplayOfElements,
              faceDetectionModel,
              loadingFacedetectionModel,
              shutterSound,
              skipModelLoading,
              loadFaceDetectionModel: this.loadFaceDetectionModel
            }
          }
        >
          {/* <Header /> */}
          <BrowserRouter>
           {isNewHeader? <AppNavbar /> : <ProgressHeader />}
            <div >
              <Routes />
            </div>
          </BrowserRouter>
          {showFooter?<Footer />:null}
        </SpeakerContext.Provider>
      </>
    );
  }
}

export default App;
